const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.25 8.75A.75.75 0 0 1 5 8h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75m0 6.5A.75.75 0 0 1 5 14.5h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75"/></svg>';
export {
  a as w
};
